import { apiClient } from "@/shared/api";

export const setAdmin = (
  userId: string
): Promise<{success: boolean}> => {
  return apiClient(`/api/users/set-admin/${userId}`, "put");
};